import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import { useRequestLinesStore } from "entities/TravelLines";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";
import { Loader } from "shared/ui";
import "./TravelLineControlsHeader.styles.css";

function TravelLineControlsHeader({
  disabled,
  travelLineIdx,
  headerText,
  travelLineId,
  isLastLine,
  isFirstLine,
  handleTravelLineDelete,
}) {
  const { t } = useTranslation("Shared");
  const requestLinesState = useRequestLinesStore(
    (state) => state.requestLinesState
  );

  const moveTravelLineUp = useRequestLinesStore(
    (state) => state.moveTravelLineUp
  );
  const moveTravelLineDown = useRequestLinesStore((state) => state.moveTravelLineDown);
  const handleRemoval = (e) => {
    e.stopPropagation();
    handleTravelLineDelete(travelLineIdx);
  };
  const handleMoveUp = (e) => {
    e.stopPropagation();
    moveTravelLineUp(travelLineIdx);
  };
  const handleMoveDown = (e) => {
    e.stopPropagation();
    moveTravelLineDown(travelLineIdx);
  };
  return (
    <Stack
      className="travel-line-header text-primary"
      gap={3}
      direction="horizontal"
    >
      <strong className="me-auto">{headerText}</strong>
      {requestLinesState[travelLineId]?.isModified && (
        <span className="text-info d-flex align-items-center">
          <FontAwesomeIcon
            shake
            icon={Icons.circleExclamation}
            className="me-3"
          />
          <small>{t("unsaved_changes")}</small>
        </span>
      )}
      {!disabled && (
        <>
          {!isLastLine && (
            <IconButton onClick={handleMoveDown}>
              <FontAwesomeIcon
                icon={Icons.arrowDown}
                className="travel-line-header__icon"
              />
            </IconButton>
          )}
          {!isFirstLine && (
            <IconButton onClick={handleMoveUp}>
              <FontAwesomeIcon
                icon={Icons.arrowUp}
                className="travel-line-header__icon"
              />
            </IconButton>
          )}
          {!(isLastLine && isFirstLine) && (
            <>
              <div className="vr" />
              {requestLinesState[travelLineId]?.isDeleting ? (
                <Loader size="sm">{t("deleting")}</Loader>
              ) : (
                <IconButton onClick={handleRemoval}>
                  <FontAwesomeIcon
                    icon={Icons.trash}
                    className="travel-line-header__icon"
                  />
                </IconButton>
              )}
              <div className="vr" />
            </>
          )}
        </>
      )}
    </Stack>
  );
}

export default TravelLineControlsHeader;
